import * as React from 'react';
import { Paper, PaperProps, Stacker, Styler, TypographyBody, TypographyHeading } from '..';
import { AutocompleterListProps } from './AutocompleterList';
import { useComponentDefaultProps } from '../../theming';

export interface AutocompleterCategoryProps extends PaperProps {
    /**
     * The child `AutocompleterList` component.
     */
    children?: React.ReactElement<AutocompleterListProps>;

    id: string;

    title?: string;

    /**
     * The appendix text.
     */
    appendix?: string;

    footerContent?: React.ReactNode;

    endDecorator?: React.ReactNode;
}

export function AutocompleterCategory(props: Readonly<AutocompleterCategoryProps>): React.JSX.Element {
    const { children, id, title, appendix, footerContent, endDecorator, ref, ...other } = useComponentDefaultProps(
        'AutocompleterCategory',
        {},
        props
    );

    return (
        <Paper ref={ref} component="li" overflow="hidden" radius="s" border={0} {...other}>
            {title && (
                <Styler p={3} pt={4} bs="solid" bw={0} bbw={1} bc="grey.lightest">
                    <Stacker direction="row" justifyContent="space-between" alignItems="flex-end">
                        <TypographyHeading component="h5" color="text.body" size="2xs" id={id}>
                            {title}
                        </TypographyHeading>
                        {appendix && (
                            <TypographyBody size="xs" color="text.light">
                                {appendix}
                            </TypographyBody>
                        )}
                        {endDecorator}
                    </Stacker>
                </Styler>
            )}
            {children}
            {footerContent && (
                <Styler p={3} bs="solid" bw={0} btw={1} bc="grey.lightest">
                    {footerContent}
                </Styler>
            )}
        </Paper>
    );
}
